import { Snackbar } from "@heathmont/moon-core-tw";
import Checkmark from "../icons/Checkmark";

type ShareToastProps = {
  isOpen: boolean;
  handleClose: () => void;
};

export const ShareToast = ({ isOpen, handleClose }: ShareToastProps) => {
  return (
    <Snackbar
      isOpen={isOpen}
      position="bottom-center"
      onOpenChange={handleClose}
      autoClose={1000}
      className="max-w-sm rounded-xl border border-BG-60 bg-white p-4 pr-6 text-black !shadow-[0_8px_8px_rgba(0,12,18,0.24)]"
    >
      <Snackbar.Icon>
        <Checkmark className="h-8 w-8" />
      </Snackbar.Icon>
      <Snackbar.Content>
        <p className="text-dark-color">Link copied to clipboard</p>
      </Snackbar.Content>
    </Snackbar>
  );
};
